import React from 'react';
import styled from 'styled-components';

export const CardBody : React.FunctionComponent = ({ children }) =>
{
    return (
        <Container>
            {children}
        </Container>
    );
};

const Container = styled.div`
    flex-grow: 1;
`;